<template>
  <div class="container-fluid">
    <page-title
      :canDownload="false"
      :title="this.$t('sites')"
      iconClasses="fas fa-university"
      :tooltipLabel="$t('site.add')"
      v-on:onButtonClick="fillEditModal(-1)"
      :isDataLoading="!downloaded"
      :isTimelineDisplayed="false"
      :hasModal="true"
      :modalId="'#editSiteModal'"
    />

    <div class="container-fluid">
      <table class="table" v-if="downloaded">
        <thead>
          <tr>
            <th scope="col">{{ $t('site.id') }}</th>
            <th scope="col">{{ $t('site.name') }}</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(site, index) in sites" :key="site.id">
            <th scope="row">{{ site.id }}</th>
            <td>{{ site.name }}</td>
            <td>
              <button
                type="button"
                class="btn btn-chart"
                data-toggle="modal"
                data-target="#editSiteModal"
                @click="fillEditModal(index)"
              >
                <i class="fas fa-pen"></i>
              </button>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-danger"
                data-toggle="modal"
                data-target="#confirmDeleteSiteModal"
                @click="setIndexToDelete(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal use to add or edit a site -->
    <div
      class="modal fade"
      id="editSiteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editSiteModalLabel"
      aria-hidden="true"
    >
      <!-- Site edition form -->
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editUserModalLabel" v-if="selectedIndex >= 0">
              {{ $t('site.edit') }}
            </h5>
            <h5 class="modal-title" id="editUserModalLabel" v-if="selectedIndex < 0">
              {{ $t('site.add') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- Body form -->
          <div class="modal-body">
            <!-- Site location-->
            <div class="form-group row">
              <label for="site-input" class="col-form-label col-sm-3">{{
                $t('site.site_location')
              }}</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="site-input"
                  v-model="editSiteForm.site"
                  :placeholder="'Ex: france.paris.louvre'"
                />
              </div>
            </div>
            <!-- Site name label -->
            <div class="form-group row">
              <label for="site-name-input" class="col-form-label col-sm-3">{{
                $t('site.name')
              }}</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="site-name-input"
                  v-model="editSiteForm.name"
                  :placeholder="$t('site.name_placeholder')"
                />
              </div>
            </div>

            <!-- Launch date -->
            <div class="form-group row">
              <label for="input-start-date" class="col-sm-3 col-form-label">{{
                $t('site.launch_date')
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  id="input-start-date"
                  v-model="editSiteForm.launch_date"
                  :value="editSiteForm.launch_date"
                  :config="datePickerConfig"
                  class="form-control"
                ></date-picker>
              </div>
            </div>

            <!-- Status -->
            <div class="form-group row">
              <label for="status-select" class="col-form-label col-sm-3"
                >{{ $t('site.status') }} :</label
              >
              <div class="col-sm-9">
                <select class="custom-select" id="log-version-select" v-model="editSiteForm.status">
                  <option value="ACTIVE" selected>{{ $t('status.ACTIVE') }}</option>
                  <option value="INACTIVE">{{ $t('status.INACTIVE') }}</option>
                </select>
              </div>
            </div>

            <!-- End date -->
            <div class="form-group row">
              <label for="input-start-date" class="col-sm-3 col-form-label">{{
                $t('site.end_date')
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  id="input-start-date"
                  v-model="editSiteForm.end_date"
                  :value="editSiteForm.end_date"
                  :config="datePickerConfig"
                  class="form-control"
                ></date-picker>
              </div>
            </div>

            <!-- Log version -->
            <div class="form-group row">
              <label for="log-version-select" class="col-form-label col-sm-3">{{
                $t('site.log_version')
              }}</label>
              <div class="col-sm-9">
                <select
                  class="custom-select"
                  id="log-version-select"
                  v-model="editSiteForm.log_version"
                >
                  <option value="4" selected>4</option>
                  <option value="3">3</option>
                </select>
              </div>
            </div>
            <!-- Languages -->
            <div class="form-group row">
              <label for="site-languages-select" class="col-form-label col-sm-3">{{
                $t('site.languages')
              }}</label>
              <div class="col-sm-9">
                <select
                  class="custom-select"
                  id="site-languages-select"
                  v-model="editSiteForm.languages"
                  multiple
                >
                  <option
                    :value="language"
                    v-for="language in configFilterHierarchy.filter_values.language"
                    :key="language"
                  >
                    {{ $t('language.' + language) }}
                  </option>
                </select>
              </div>
            </div>
            <!-- Products -->
            <div class="form-group row">
              <label for="site-products-select" class="col-form-label col-sm-3">{{
                $t('site.products')
              }}</label>
              <div class="col-sm-9">
                <select
                  class="custom-select"
                  id="site-products-select"
                  v-model="editSiteForm.products"
                  multiple
                >
                  <option
                    :value="product"
                    v-for="product in configFilterHierarchy.filter_values.product"
                    :key="product"
                  >
                    {{ product }}
                  </option>
                </select>
              </div>
            </div>
            <!-- Total treasure count -->
            <div class="form-group row">
              <label for="total-treasure-count-input" class="col-form-label col-sm-3">{{
                $t('site.total_treasure_count')
              }}</label>
              <div class="col-sm-9">
                <input
                  type="number"
                  class="form-control"
                  id="total-treasure-count-input"
                  v-model="editSiteForm.total_treasure_count"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="has-survey-select" class="col-form-label col-sm-3">{{
                $t('site.has_survey')
              }}</label>
              <div class="col-sm-9">
                <select
                  class="custom-select"
                  id="has-survey-select"
                  v-model="editSiteForm.has_survey"
                >
                  <option value="true">{{ $t('yes') }}</option>
                  <option value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="has-map-select" class="col-form-label col-sm-3">{{
                $t('site.has_map')
              }}</label>
              <div class="col-sm-9">
                <select class="custom-select" id="has-map-select" v-model="editSiteForm.has_map">
                  <option value="true">{{ $t('yes') }}</option>
                  <option value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="default-level-input" class="col-form-label col-sm-3">{{
                $t('site.default_level')
              }}</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="default-level-input"
                  v-model="editSiteForm.default_level"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="levels-input" class="col-form-label col-sm-3">{{
                $t('site.levels')
              }}</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="levels-input"
                  v-model="editSiteForm.levels"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="levels-input" class="col-form-label col-sm-3">{{
                $t('site.url_placeholder')
              }}</label>
              <div class="col-sm-9">
                <vue-tags-input
                  class="tags-input"
                  v-model="editSiteForm.temp_authorized_urls"
                  :tags="editSiteForm.authorized_urls"
                  :validation="hostnameValidation"
                  :placeholder="$t('site.url_placeholder')"
                  @tags-changed="newTags => (editSiteForm.authorized_urls = newTags)"
                  :add-only-from-autocomplete="false"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="onUpdateSite"
            >
              {{ editSiteForm.id > 1 ? $t('add') : $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal use to confirm user suppression -->
    <div
      class="modal fade"
      id="confirmDeleteSiteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmDeleteSiteModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmDeleteSiteModalLabel" v-if="selectedIndex >= 0">
              {{ $t('modal.confirm_user_delete', [sites[selectedIndex].name]) }}
            </h5>
            <h5 class="modal-title" id="confirmDeleteSiteModalLabel" v-if="selectedIndex < 0">
              {{ $t('modal.confirm_user_delete') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="onDeleteSite">
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import VueTagsInput from '@johmun/vue-tags-input'
import moment from 'moment'
import { utilsMixin } from '../utils/mixins'

export default {
  name: 'Site',
  dependencies: ['adminService'],
  mixins: [utilsMixin],
  data() {
    return {
      downloaded: false,
      editSiteForm: {
        id: 0,
        name: '',
        launch_date: moment(new Date()).format('DD/MM/YYYY'),
        end_date: null,
        status: 'ACTIVE',
        site: '',
        languages: [],
        products: [],
        total_treasure_count: 0,
        has_survey: false,
        has_map: false,
        default_level: 0,
        levels: '0',
        authorized_urls: [],
        temp_authorized_urls: '',
      },
      sites: [],
      selectedIndex: -1,
      startDate:
        this.$route.params.start != undefined
          ? new Date(this.$route.params.start)
          : moment().subtract(1, 'month'),
      endDate:
        this.$route.params.end != undefined
          ? new Date(this.$route.params.end)
          : moment(new Date(), 'YYYY-MM-DD'),
      hostnameValidation: [
        {
          classes: 'text-danger',
          // eslint-disable-next-line
          rule: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/,
          disableAdd: true,
        },
      ],
    }
  },
  mounted() {
    setTimeout(() => {
      this.fetchSites()
    }, 300)
  },
  computed: {
    datePickerConfig: function() {
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: this.$locale,
      }
    },
  },
  components: {
    datePicker,
    VueTagsInput,
    'page-title': () => import('./utils/PageTitle'),
  },
  methods: {
    fetchSites: function() {
      this.adminService
        .getAllSites()
        .then(data => {
          this.sites = data
          this.sites.forEach(site => {
            if (site.authorized_urls && site.authorized_urls.length > 0) {
              site.authorized_urls = JSON.parse(site.authorized_urls).map(url => {
                return { text: url, id: url }
              })
            }
          })
          this.downloaded = true
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    setIndexToDelete: function(index) {
      this.selectedIndex = index
    },
    fillEditModal: function(index) {
      this.selectedIndex = index
      if (index < 0) {
        this.editSiteForm = {
          id: 0,
          name: '',
          site: '',
          launch_date: moment(new Date()).format(this.dateFormat),
          end_date: null,
          status: 'ACTIVE',
          log_version: 4,
          languages: [],
          total_treasure_count: 0,
          products: [],
          has_survey: false,
          has_map: false,
          default_level: 0,
          levels: '0',
          authorized_urls: [],
          temp_authorized_urls: '',
        }
      } else {
        const selectedSite = this.sites[index]
        this.editSiteForm = {
          id: selectedSite.id,
          name: selectedSite.name,
          site: selectedSite.site,
          launch_date: moment(selectedSite.launch_date, 'YYYY-MM-DD').format(this.dateFormat),
          end_date: moment(selectedSite.end_date, 'YYYY-MM-DD').format(this.dateFormat),
          status: selectedSite.status,
          log_version: selectedSite.log_version,
          languages: selectedSite.languages,
          total_treasure_count: selectedSite.total_treasure_count,
          products: selectedSite.products,
          has_survey: selectedSite.has_survey,
          has_map: selectedSite.has_map,
          default_level: selectedSite.default_level,
          levels: selectedSite.levels,
          authorized_urls: selectedSite.authorized_urls ? selectedSite.authorized_urls : [],
          temp_authorized_urls: '',
        }
      }
    },
    onDeleteSite: function() {
      const idToDelete = this.sites[this.selectedIndex].id
      this.adminService
        .deleteSite(idToDelete)
        .then(() => {
          this.showToast(this.$t('admin.site.delete', [this.sites[this.selectedIndex].name]))
          this.sites.splice(this.selectedIndex, 1)
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    onUpdateSite: function() {
      Promise.resolve()
        .then(() => {
          let form = JSON.parse(JSON.stringify(this.editSiteForm))

          form.launch_date = moment(this.editSiteForm.launch_date, 'DD/MM/YYYY').format(
            'YYYY-MM-DD',
          )

          if (moment(this.editSiteForm.end_date, 'DD/MM/YYYY').isValid()) {
            form.end_date = moment(this.editSiteForm.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          form.authorized_urls = JSON.stringify(
            this.editSiteForm.authorized_urls.map(url => {
              return url.text
            }),
          )

          if (form.id > 0) {
            return this.adminService.updateSite(form)
          } else {
            return this.adminService.createSite(form)
          }
        })
        .then(data => {
          var updatedSite = data.result
          const siteToUpdate = {
            id: updatedSite.id,
            name: updatedSite.name,
            site: updatedSite.site,
            launch_date: moment(updatedSite.launch_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            end_date: moment(updatedSite.end_date).isValid()
              ? moment(updatedSite.end_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : null,
            log_version: updatedSite.log_version,
            languages: updatedSite.languages,
            total_treasure_count: updatedSite.total_treasure_count,
            products: updatedSite.products,
            has_survey: updatedSite.has_survey,
            has_map: updatedSite.has_map,
            default_level: updatedSite.default_level,
            levels: updatedSite.levels,
            authorized_urls: JSON.parse(updatedSite.authorized_urls).map(url => {
              return { text: url, id: url }
            }),
          }
          if (this.selectedIndex >= 0) {
            this.$set(this.sites, this.selectedIndex, siteToUpdate)
            this.showToast(this.$t('admin.site.update', [siteToUpdate.name]))
          } else {
            this.sites.push(siteToUpdate)
            this.showToast(this.$t('admin.site.create', [siteToUpdate.name]))
          }
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
  },
}
</script>

<style>
.starter-template {
  padding: 3rem 1.5rem;
  text-align: center;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > th {
  vertical-align: middle;
}
</style>
